import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { getDraft, type ContactDraft } from "@/lib/draftModals"

/** Prueft ?restore_draft=<id> — wenn es einen ContactDraft gibt der zur
 *  gerenderten sourceId gehoert, wird das CreateContactModal dafuer geoeffnet.
 *  Der URL-Parameter wird nach Verarbeitung entfernt (replace-state) damit
 *  Reload nicht nochmal triggert.
 *
 *  Usage in Card/Detail-Komponente:
 *    const { restoreOpen, draft, consume } = useContactDraftRestore(itemId)
 *    <CreateContactModal
 *      open={createOpen || restoreOpen}
 *      draftId={draft?.id}
 *      draftPrefill={draft}
 *      onClose={() => { setCreateOpen(false); consume() }}
 *      ... />
 */
export function useContactDraftRestore(sourceId: number | string) {
  const [params, setParams] = useSearchParams()
  const [draft, setDraft] = useState<ContactDraft | null>(null)

  useEffect(() => {
    const id = params.get("restore_draft")
    if (!id) return
    const d = getDraft(id)
    if (!d || d.kind !== "contact") return
    if (String(d.sourceId) !== String(sourceId)) return
    setDraft(d as ContactDraft)
    // URL saeubern
    const next = new URLSearchParams(params)
    next.delete("restore_draft")
    setParams(next, { replace: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourceId])

  const consume = () => setDraft(null)

  return { restoreOpen: !!draft, draft, consume }
}
